import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const DownloadMedia = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M5.71716 17.6738L13.4672 10.2363L17.9047 14.5488V14.8613C17.9047 16.4146 16.6455 17.6738 15.0922 17.6738H5.71716ZM5.71716 17.6738C4.16386 17.6738 2.90466 16.4146 2.90466 14.8613V5.48633C2.90466 3.93303 4.16386 2.67383 5.71716 2.67383H10.8422M8.52966 6.89258C8.52966 7.66923 7.90006 8.29883 7.12341 8.29883C6.34676 8.29883 5.71716 7.66923 5.71716 6.89258C5.71716 6.11593 6.34676 5.48633 7.12341 5.48633C7.90006 5.48633 8.52966 6.11593 8.52966 6.89258Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7173 5.45552L15.8603 8.29883M15.8603 8.29883L13.1298 5.58404M15.8603 8.29883V1.48633"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default DownloadMedia
